// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ───────────────────────── Go Live gating ───────────────────────── */

/* Disabled state of the Go Live button */
.Credential_goLiveBtnDisabled__9jnI3 {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(0.4);
}

.Credential_goLiveBtnDisabled__9jnI3:hover {
  /* neutralize any hover lift/shadow from the base .goLiveBtn */
  transform: none;
  box-shadow: none;
}

/* Success line under the draft note */
.Credential_draftNoteSuccess__yTUlE {
  display: block;
  margin-top: 6px;
  color: #166534;
  font-size: 12px;
  font-weight: 500;
}

/* Blocked-state notice shown when no bot is configured */
.Credential_draftBlockedNote__-36gY {
  margin-top: 12px;
  padding: 14px 16px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-left: 3px solid #f59e0b;
  border-radius: 8px;
  text-align: left;
}

.Credential_draftBlockedTitle__r-Cdp {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.Credential_draftBlockedBody__Xj8Ic {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #92400e;
  line-height: 1.6;
}

.Credential_draftBlockedList__6iEvt {
  margin: 0 0 10px 0;
  padding-left: 18px;
  font-size: 12px;
  color: #78350f;
  line-height: 1.7;
}

.Credential_draftBlockedList__6iEvt li {
  margin-bottom: 4px;
}

.Credential_draftBlockedFooter__yL8CP {
  margin: 0;
  font-size: 12px;
  color: #78350f;
  font-style: italic;
  line-height: 1.5;
}

/* Draft section styles */
.Credential_draftSection__C44cr {
  background-color: #fff3e0;
  border: 1px solid #ff9800;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.Credential_liveBadge__k7T57 {
  background: var(--success);
  color: var(--bg-primary);
  font-size: 12px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Credential_draftBadge__tA8UC {
  background-color: #ff9800;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Credential_goLiveBtn__acFQS {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: background-color 0.3s;
}

.Credential_goLiveBtn__acFQS:hover:not(:disabled) {
  background-color: #45a049;
}

.Credential_goLiveBtn__acFQS:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.Credential_draftNote__2BCy6 {
  color: #666;
  font-size: 14px;
  margin: 0;
  font-style: italic;
}

/* Status indicators */
.Credential_draftStatus__Nonf4 {
  color: #ff9800;
  font-weight: bold;
  background-color: #fff3e0;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.Credential_liveStatus__4Bsxf {
  color: #4caf50;
  font-weight: bold;
  background-color: #e8f5e9;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.Credential_rowFlex__N5-6h {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Credential_masked__nJkXd {
  letter-spacing: 2px;
  filter: blur(3px);
  cursor: pointer;
}

.Credential_masked__nJkXd:hover {
  filter: blur(0px);
}

.Credential_copyBtn__fuE9j {
  padding: 4px 10px;
  font-size: 12px;
  background: var(--primary);
  color: var(--bg-primary);
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.Credential_copyBtn__fuE9j:hover {
  background: #2563eb;
}

.Credential_container__jO9Kq {
  width: 100%;
  /* background-color: var(--white-color); */
  border-radius: 1px;
  padding: 2rem;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
  height: 100%;
  /* border-radius: 10px; */
}

.Credential_title__KYPXg {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}

.Credential_credentialsBox__BglCh {
  overflow-x: auto;
}
.Credential_showHideBtn__556Pd {
  margin-bottom: 20px;
  padding: 8px 16px;
  background-color: var(--primary);
  color: white;
  border: medium;
  border-radius: 4px;
  cursor: pointer;
}
.Credential_table__b9EtW {
  width: 100%;
  /* border-collapse: collapse; */
  /* background: #fafafa; */
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--border);
  background: var(--gradient-card);
  box-shadow: var(--shadow-lg);
}
.Credential_table__b9EtW tr,
.Credential_table__b9EtW td {
  padding: 12px;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  height: 52px;
}
.Credential_table__b9EtW td {
  color: #334155;
  border-bottom: 1px solid #e7e6e6;
  background-color: #f6f8ff;
}

.Credential_table__b9EtW tr:last-child td {
  border-bottom: none;
}

.Credential_table__b9EtW td:first-child {
  font-weight: 500;
  color: #0f172a;
  width: 25%;
  background: #f5f5f5;
  border-right: 1px solid #ddd;
}

.Credential_table__b9EtW td:last-child {
  color: #1e293b;
  word-break: break-all;
}
.Credential_table__b9EtW tr:hover td {
  background-color: #ebf1ff;
}

tbody tr:hover {
  background-color: #f1f1f1;
}
tr:nth-child(even) {
  background-color: #f9f9f9;
  position: relative;
}
tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f1f1f1;
}

@media (max-width: 360px) {
  .Credential_table__b9EtW {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* width: auto; */
  }
  .Credential_container__jO9Kq {
    padding: 16px;
    padding-right: 0px;
  }
  .Credential_credentialsBox__BglCh table {
    table-layout: fixed;
    width: 100%;
  }
  .Credential_credentialsBox__BglCh td {
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }
  .Credential_table__b9EtW td {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .Credential_container__jO9Kq {
    padding: 16px;
  }
}

@media (max-width: 576px) {
  .Credential_container__jO9Kq {
    padding-right: 0rem;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .Credential_table__b9EtW {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }
  .Credential_credentialsBox__BglCh table {
    table-layout: fixed;
    width: 100%;
  }
  .Credential_credentialsBox__BglCh td {
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }
  .Credential_container__jO9Kq {
    padding-right: 0rem;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
}
@media (min-width: 993px) and (max-width: 1200px) {
}
/* @media (min-width: 1400px) { }  */
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/Credential.module.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,yCAAyC;AACzC;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;AACA;AACA;AACA;AACA,oCAAoC","sourcesContent":["/* ───────────────────────── Go Live gating ───────────────────────── */\n\n/* Disabled state of the Go Live button */\n.goLiveBtnDisabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  filter: grayscale(0.4);\n}\n\n.goLiveBtnDisabled:hover {\n  /* neutralize any hover lift/shadow from the base .goLiveBtn */\n  transform: none;\n  box-shadow: none;\n}\n\n/* Success line under the draft note */\n.draftNoteSuccess {\n  display: block;\n  margin-top: 6px;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Blocked-state notice shown when no bot is configured */\n.draftBlockedNote {\n  margin-top: 12px;\n  padding: 14px 16px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-left: 3px solid #f59e0b;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.draftBlockedTitle {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.draftBlockedBody {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  color: #92400e;\n  line-height: 1.6;\n}\n\n.draftBlockedList {\n  margin: 0 0 10px 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #78350f;\n  line-height: 1.7;\n}\n\n.draftBlockedList li {\n  margin-bottom: 4px;\n}\n\n.draftBlockedFooter {\n  margin: 0;\n  font-size: 12px;\n  color: #78350f;\n  font-style: italic;\n  line-height: 1.5;\n}\n\n/* Draft section styles */\n.draftSection {\n  background-color: #fff3e0;\n  border: 1px solid #ff9800;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.liveBadge {\n  background: var(--success);\n  color: var(--bg-primary);\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 12px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.draftBadge {\n  background-color: #ff9800;\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 12px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.goLiveBtn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.goLiveBtn:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.goLiveBtn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.draftNote {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n  font-style: italic;\n}\n\n/* Status indicators */\n.draftStatus {\n  color: #ff9800;\n  font-weight: bold;\n  background-color: #fff3e0;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.liveStatus {\n  color: #4caf50;\n  font-weight: bold;\n  background-color: #e8f5e9;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.rowFlex {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.masked {\n  letter-spacing: 2px;\n  filter: blur(3px);\n  cursor: pointer;\n}\n\n.masked:hover {\n  filter: blur(0px);\n}\n\n.copyBtn {\n  padding: 4px 10px;\n  font-size: 12px;\n  background: var(--primary);\n  color: var(--bg-primary);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.copyBtn:hover {\n  background: #2563eb;\n}\n\n.container {\n  width: 100%;\n  /* background-color: var(--white-color); */\n  border-radius: 1px;\n  padding: 2rem;\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n  height: 100%;\n  /* border-radius: 10px; */\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n  text-align: center;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.credentialsBox {\n  overflow-x: auto;\n}\n.showHideBtn {\n  margin-bottom: 20px;\n  padding: 8px 16px;\n  background-color: var(--primary);\n  color: white;\n  border: medium;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.table {\n  width: 100%;\n  /* border-collapse: collapse; */\n  /* background: #fafafa; */\n  border-radius: 14px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n  background: var(--gradient-card);\n  box-shadow: var(--shadow-lg);\n}\n.table tr,\n.table td {\n  padding: 12px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 400;\n  height: 52px;\n}\n.table td {\n  color: #334155;\n  border-bottom: 1px solid #e7e6e6;\n  background-color: #f6f8ff;\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.table td:first-child {\n  font-weight: 500;\n  color: #0f172a;\n  width: 25%;\n  background: #f5f5f5;\n  border-right: 1px solid #ddd;\n}\n\n.table td:last-child {\n  color: #1e293b;\n  word-break: break-all;\n}\n.table tr:hover td {\n  background-color: #ebf1ff;\n}\n\ntbody tr:hover {\n  background-color: #f1f1f1;\n}\ntr:nth-child(even) {\n  background-color: #f9f9f9;\n  position: relative;\n}\ntbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n@media (max-width: 360px) {\n  .table {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    /* width: auto; */\n  }\n  .container {\n    padding: 16px;\n    padding-right: 0px;\n  }\n  .credentialsBox table {\n    table-layout: fixed;\n    width: 100%;\n  }\n  .credentialsBox td {\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n  .table td {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .container {\n    padding-right: 0rem;\n  }\n}\n\n@media (min-width: 577px) and (max-width: 768px) {\n  .table {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n  }\n  .credentialsBox table {\n    table-layout: fixed;\n    width: 100%;\n  }\n  .credentialsBox td {\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n  }\n  .container {\n    padding-right: 0rem;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 992px) {\n}\n@media (min-width: 993px) and (max-width: 1200px) {\n}\n/* @media (min-width: 1400px) { }  */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goLiveBtnDisabled": `Credential_goLiveBtnDisabled__9jnI3`,
	"draftNoteSuccess": `Credential_draftNoteSuccess__yTUlE`,
	"draftBlockedNote": `Credential_draftBlockedNote__-36gY`,
	"draftBlockedTitle": `Credential_draftBlockedTitle__r-Cdp`,
	"draftBlockedBody": `Credential_draftBlockedBody__Xj8Ic`,
	"draftBlockedList": `Credential_draftBlockedList__6iEvt`,
	"draftBlockedFooter": `Credential_draftBlockedFooter__yL8CP`,
	"draftSection": `Credential_draftSection__C44cr`,
	"liveBadge": `Credential_liveBadge__k7T57`,
	"draftBadge": `Credential_draftBadge__tA8UC`,
	"goLiveBtn": `Credential_goLiveBtn__acFQS`,
	"draftNote": `Credential_draftNote__2BCy6`,
	"draftStatus": `Credential_draftStatus__Nonf4`,
	"liveStatus": `Credential_liveStatus__4Bsxf`,
	"rowFlex": `Credential_rowFlex__N5-6h`,
	"masked": `Credential_masked__nJkXd`,
	"copyBtn": `Credential_copyBtn__fuE9j`,
	"container": `Credential_container__jO9Kq`,
	"title": `Credential_title__KYPXg`,
	"credentialsBox": `Credential_credentialsBox__BglCh`,
	"showHideBtn": `Credential_showHideBtn__556Pd`,
	"table": `Credential_table__b9EtW`
};
export default ___CSS_LOADER_EXPORT___;
